import axios from 'axios';

export const axiosConfigBuilder = (
  token,
  baseUrl = '',
  headers = {},
  ...customConfig
) => {
  const axiosInstance = axios.create({
    baseUrl,
    headers: {
      Authorization: token,
      ...headers,
    },
    ...customConfig,
  });

  return axiosInstance;
};

export const axiosTrackerConfigBuilder = (apiUrl) => {
  const axiosInstance = axios.create({
    baseURL: apiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return axiosInstance;
};
